const githubAppEndpoints = {
	authorize: '/oauth/github/authorize',
	identity: '/session/github/identity',
	installations: '/session/github/installations',
	install: '/workspace/github/installations/authorize',
};

const githubIdentityAuthorized = user => user?.githubIdentity?.status === 'active';

const githubInstallationActive = installation => installation?.status === 'active';

const githubInstallationAvailable = account => account?.githubInstallationStatus === 'installed';

const githubInstallationId = installation => installation?.githubInstallationId || installation?.id;

const githubRedirectUrl = response => response?.data?.url || response?.data?.authorizationUrl || response?.url;

export {
	githubAppEndpoints,
	githubIdentityAuthorized,
	githubInstallationActive,
	githubInstallationAvailable,
	githubInstallationId,
	githubRedirectUrl,
};
